/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppUpdateRouteImport } from './routes/app-update'
import { Route as BonusRouteImport } from './routes/bonus'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as InvitationPriceRouteImport } from './routes/invitation-price'
import { Route as KycRouteImport } from './routes/kyc'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MailingRouteImport } from './routes/mailing'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as PlusRouteImport } from './routes/plus'
import { Route as PublicationsRouteImport } from './routes/publications'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RolesRouteImport } from './routes/roles'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupBonusRouteImport } from './routes/signup-bonus'
import { Route as SupportRouteImport } from './routes/support'
import { Route as UsersRouteImport } from './routes/users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUpdateRoute = AppUpdateRouteImport.update({
  id: '/app-update',
  path: '/app-update',
  getParentRoute: () => rootRouteImport,
} as any)
const BonusRoute = BonusRouteImport.update({
  id: '/bonus',
  path: '/bonus',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationPriceRoute = InvitationPriceRouteImport.update({
  id: '/invitation-price',
  path: '/invitation-price',
  getParentRoute: () => rootRouteImport,
} as any)
const KycRoute = KycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MailingRoute = MailingRouteImport.update({
  id: '/mailing',
  path: '/mailing',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesRoute = PackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const PlusRoute = PlusRouteImport.update({
  id: '/plus',
  path: '/plus',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicationsRoute = PublicationsRouteImport.update({
  id: '/publications',
  path: '/publications',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesRoute = RolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupBonusRoute = SignupBonusRouteImport.update({
  id: '/signup-bonus',
  path: '/signup-bonus',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app-update': typeof AppUpdateRoute
  '/bonus': typeof BonusRoute
  '/configuration': typeof ConfigurationRoute
  '/invitation-price': typeof InvitationPriceRoute
  '/kyc': typeof KycRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/messages': typeof MessagesRoute
  '/notifications': typeof NotificationsRoute
  '/packages': typeof PackagesRoute
  '/payments': typeof PaymentsRoute
  '/plus': typeof PlusRoute
  '/publications': typeof PublicationsRoute
  '/reports': typeof ReportsRoute
  '/roles': typeof RolesRoute
  '/settings': typeof SettingsRoute
  '/signup-bonus': typeof SignupBonusRoute
  '/support': typeof SupportRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app-update': typeof AppUpdateRoute
  '/bonus': typeof BonusRoute
  '/configuration': typeof ConfigurationRoute
  '/invitation-price': typeof InvitationPriceRoute
  '/kyc': typeof KycRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/messages': typeof MessagesRoute
  '/notifications': typeof NotificationsRoute
  '/packages': typeof PackagesRoute
  '/payments': typeof PaymentsRoute
  '/plus': typeof PlusRoute
  '/publications': typeof PublicationsRoute
  '/reports': typeof ReportsRoute
  '/roles': typeof RolesRoute
  '/settings': typeof SettingsRoute
  '/signup-bonus': typeof SignupBonusRoute
  '/support': typeof SupportRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app-update': typeof AppUpdateRoute
  '/bonus': typeof BonusRoute
  '/configuration': typeof ConfigurationRoute
  '/invitation-price': typeof InvitationPriceRoute
  '/kyc': typeof KycRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/messages': typeof MessagesRoute
  '/notifications': typeof NotificationsRoute
  '/packages': typeof PackagesRoute
  '/payments': typeof PaymentsRoute
  '/plus': typeof PlusRoute
  '/publications': typeof PublicationsRoute
  '/reports': typeof ReportsRoute
  '/roles': typeof RolesRoute
  '/settings': typeof SettingsRoute
  '/signup-bonus': typeof SignupBonusRoute
  '/support': typeof SupportRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app-update'
    | '/bonus'
    | '/configuration'
    | '/invitation-price'
    | '/kyc'
    | '/login'
    | '/mailing'
    | '/messages'
    | '/notifications'
    | '/packages'
    | '/payments'
    | '/plus'
    | '/publications'
    | '/reports'
    | '/roles'
    | '/settings'
    | '/signup-bonus'
    | '/support'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app-update'
    | '/bonus'
    | '/configuration'
    | '/invitation-price'
    | '/kyc'
    | '/login'
    | '/mailing'
    | '/messages'
    | '/notifications'
    | '/packages'
    | '/payments'
    | '/plus'
    | '/publications'
    | '/reports'
    | '/roles'
    | '/settings'
    | '/signup-bonus'
    | '/support'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/app-update'
    | '/bonus'
    | '/configuration'
    | '/invitation-price'
    | '/kyc'
    | '/login'
    | '/mailing'
    | '/messages'
    | '/notifications'
    | '/packages'
    | '/payments'
    | '/plus'
    | '/publications'
    | '/reports'
    | '/roles'
    | '/settings'
    | '/signup-bonus'
    | '/support'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppUpdateRoute: typeof AppUpdateRoute
  BonusRoute: typeof BonusRoute
  ConfigurationRoute: typeof ConfigurationRoute
  InvitationPriceRoute: typeof InvitationPriceRoute
  KycRoute: typeof KycRoute
  LoginRoute: typeof LoginRoute
  MailingRoute: typeof MailingRoute
  MessagesRoute: typeof MessagesRoute
  NotificationsRoute: typeof NotificationsRoute
  PackagesRoute: typeof PackagesRoute
  PaymentsRoute: typeof PaymentsRoute
  PlusRoute: typeof PlusRoute
  PublicationsRoute: typeof PublicationsRoute
  ReportsRoute: typeof ReportsRoute
  RolesRoute: typeof RolesRoute
  SettingsRoute: typeof SettingsRoute
  SignupBonusRoute: typeof SignupBonusRoute
  SupportRoute: typeof SupportRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-update': {
      id: '/app-update'
      path: '/app-update'
      fullPath: '/app-update'
      preLoaderRoute: typeof AppUpdateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bonus': {
      id: '/bonus'
      path: '/bonus'
      fullPath: '/bonus'
      preLoaderRoute: typeof BonusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation-price': {
      id: '/invitation-price'
      path: '/invitation-price'
      fullPath: '/invitation-price'
      preLoaderRoute: typeof InvitationPriceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kyc': {
      id: '/kyc'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof KycRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mailing': {
      id: '/mailing'
      path: '/mailing'
      fullPath: '/mailing'
      preLoaderRoute: typeof MailingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages': {
      id: '/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plus': {
      id: '/plus'
      path: '/plus'
      fullPath: '/plus'
      preLoaderRoute: typeof PlusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/publications': {
      id: '/publications'
      path: '/publications'
      fullPath: '/publications'
      preLoaderRoute: typeof PublicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles': {
      id: '/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof RolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup-bonus': {
      id: '/signup-bonus'
      path: '/signup-bonus'
      fullPath: '/signup-bonus'
      preLoaderRoute: typeof SignupBonusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppUpdateRoute: AppUpdateRoute,
  BonusRoute: BonusRoute,
  ConfigurationRoute: ConfigurationRoute,
  InvitationPriceRoute: InvitationPriceRoute,
  KycRoute: KycRoute,
  LoginRoute: LoginRoute,
  MailingRoute: MailingRoute,
  MessagesRoute: MessagesRoute,
  NotificationsRoute: NotificationsRoute,
  PackagesRoute: PackagesRoute,
  PaymentsRoute: PaymentsRoute,
  PlusRoute: PlusRoute,
  PublicationsRoute: PublicationsRoute,
  ReportsRoute: ReportsRoute,
  RolesRoute: RolesRoute,
  SettingsRoute: SettingsRoute,
  SignupBonusRoute: SignupBonusRoute,
  SupportRoute: SupportRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
